var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenomicsMobileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 318.83 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fec44b;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fee681;\n      }\n\n      .cls-3 {\n        fill: #e1a22d;\n      }\n\n      .cls-7 {\n        fill: none;\n        stroke: #fec44b;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        fill: #32adff;\n      }\n\n      .cls-5 {\n        fill: #fbe4cb;\n      }\n\n      .cls-6 {\n        fill: #fac542;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 10.59,
    width: 318.83,
    height: 58.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.95,
    y: 5.58,
    width: 304.93,
    height: 68.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.46,
    width: 289.9,
    height: 80
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.9,
    y1: 7.84,
    x2: 294.93,
    y2: 7.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.9,
    y1: 72.16,
    x2: 294.93,
    y2: 72.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.56,
    y: 17.94,
    width: 11.15,
    height: 14.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.56,
    y: 31.84,
    width: 11.15,
    height: 18.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 12.56,
    y: 50.75,
    width: 11.15,
    height: 7.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.56,
    y: 58.67,
    width: 11.15,
    height: 3.38
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 12.56,
    y1: 13.78,
    x2: 23.72,
    y2: 13.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 12.56,
    y1: 66.22,
    x2: 23.72,
    y2: 66.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 295,
    y: 17.94,
    width: 11.15,
    height: 14.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 295,
    y: 31.84,
    width: 11.15,
    height: 18.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295,
    y: 50.75,
    width: 11.15,
    height: 7.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 295,
    y: 58.67,
    width: 11.15,
    height: 3.38
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 295,
    y1: 13.78,
    x2: 306.15,
    y2: 13.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 295,
    y1: 66.22,
    x2: 306.15,
    y2: 66.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m47.61,48.66v-14.44h-3.61v-3.61h14.44v3.61h-3.61v14.44h-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.26,48.66v-3.61h-3.61v-10.83h3.61v-3.61h10.83v3.61h3.61v10.83h-3.61v3.61h-10.83Zm3.61-3.75h3.61v-10.54h-3.61v10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.91,48.66v-18.04h7.22v3.61h3.61v-3.61h7.22v3.61h-3.61v3.61h-3.61v3.61h3.61v3.61h3.61v3.61h-7.22v-3.61h-3.61v3.61h-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m116.18,48.66v-18.04h14.44v3.61h-7.22v3.61h7.22v3.61h-7.22v3.61h7.22v3.61h-14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m137.83,48.66v-18.04h7.22v3.61h3.61v3.61h3.61v-7.22h7.22v18.04h-7.22v-3.61h-3.61v-3.61h-3.61v7.22h-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m170.31,48.66v-3.61h-3.61v-10.83h3.61v-3.61h10.83v3.61h3.61v10.83h-3.61v3.61h-10.83Zm3.61-3.75h3.61v-10.54h-3.61v10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m191.96,48.66v-18.04h7.22v3.61h7.22v-3.61h7.22v18.04h-7.22v-7.22h-7.22v7.22h-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m220.84,48.66v-18.04h7.22v18.04h-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m238.88,48.66v-3.61h-3.61v-10.83h3.61v-3.61h10.83v3.61h3.61v3.61h-7.22v-3.61h-3.61v10.83h3.61v-3.61h7.22v3.61h-3.61v3.61h-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m260.53,48.66v-3.61h10.83v-3.61h-7.22v-3.61h-3.61v-3.61h3.61v-3.61h14.44v3.61h-10.83v3.61h7.22v3.61h3.61v3.61h-3.61v3.61h-14.44Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenomicsMobileBlue);
export default __webpack_public_path__ + "static/media/tokenomics-mobile-blue.fbdc5467a9d596e547eb703a07f5498d.svg";
export { ForwardRef as ReactComponent };